import NavMenu from "@/components/NavMenu"
import NavItem from "@/components/NavItem"
import Hamburger from "@/components/Hamburger"
import PageContainer from "@/components/PageContainer"
import FlashMessage from "@/components/FlashMessage"

const isAbsoluteUrl = url => url.match(/^\/[^/]?/);

export default {
    data(){
        return {
            navOpened: false,
            navMQ: ["xsmall", "small"/* , "medium" */],
            enabled: true,
        };
    },
    components: {
        NavMenu,
        NavItem,
        Hamburger,
        PageContainer,
        FlashMessage,
    },
    computed: {
        isOpen(){
            return this.navOpened && this.navMQ.includes(this.$mq);
        },
    },
    methods: {
        handleNavChange(url){
            if(isAbsoluteUrl(url))
                location.href = url;
        },
        goTo(url, canNav){
            if(!!canNav)
                this.handleNavChange(url);
        },
        showTabs(){
            this.enabled = true;
        },
        hideTabs(){
            this.enabled = false;
        },
    }
}